var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature4Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79298 1.66406C5.36828 1.66406 5.83465 2.13043 5.83465 2.70573V3.7474H6.87632C7.45162 3.7474 7.91799 4.21377 7.91799 4.78907C7.91799 5.36437 7.45162 5.83074 6.87632 5.83074H5.83465V6.87241C5.83465 7.44771 5.36828 7.91408 4.79298 7.91408C4.21768 7.91408 3.75131 7.44771 3.75131 6.87241V5.83074H2.70964C2.13434 5.83074 1.66797 5.36437 1.66797 4.78907C1.66797 4.21377 2.13434 3.7474 2.70964 3.7474H3.75131V2.70573C3.75131 2.13043 4.21768 1.66406 4.79298 1.66406ZM4.79298 12.0808C5.36828 12.0808 5.83465 12.5471 5.83465 13.1224V14.1641H6.87632C7.45162 14.1641 7.91799 14.6305 7.91799 15.2058C7.91799 15.7811 7.45162 16.2474 6.87632 16.2474H5.83465V17.2891C5.83465 17.8644 5.36828 18.3308 4.79298 18.3308C4.21768 18.3308 3.75131 17.8644 3.75131 17.2891V16.2474H2.70964C2.13434 16.2474 1.66797 15.7811 1.66797 15.2058C1.66797 14.6305 2.13434 14.1641 2.70964 14.1641H3.75131V13.1224C3.75131 12.5471 4.21768 12.0808 4.79298 12.0808Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0846 1.66406C12.5573 1.66406 12.9707 1.98227 13.0916 2.43918L14.32 7.07963L17.8135 9.09514C18.136 9.28117 18.3346 9.62515 18.3346 9.99742C18.3346 10.3697 18.136 10.7137 17.8135 10.8997L14.32 12.9152L13.0916 17.5557C12.9707 18.0126 12.5573 18.3308 12.0846 18.3308C11.612 18.3308 11.1986 18.0126 11.0776 17.5557L9.84927 12.9152L6.35577 10.8997C6.03331 10.7137 5.83465 10.3697 5.83465 9.99742C5.83465 9.62515 6.03331 9.28118 6.35577 9.09515L9.84927 7.07963L11.0776 2.43918C11.1986 1.98227 11.612 1.66406 12.0846 1.66406Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4Icon);
export default __webpack_public_path__ + "static/media/feature-4-icon.a065d7e687b1c85bebb3aeb6bbe7e805.svg";
export { ForwardRef as ReactComponent };